import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState, TBoardId } from '../../../../types/types';
import { clickManagerActionSet } from '../store/clickManager/actions/clickManagerActionSet';
import { getSelectedCards } from '../selectors/getSelectedCards';
import { selectedCardIdsSet } from '../store/clickManagerModel/actions/selectedCardIdsSet';

export const deselectCards: ActionCreator<ThunkAction> = (
    boardId: TBoardId
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const selectedCards = getSelectedCards(state, boardId);
        if (selectedCards && selectedCards.length) {
            dispatch(clickManagerActionSet(boardId, selectedCardIdsSet([], false)));
        }
    };
    return action;
};
